import { ConfigRulesDetail } from './ConfigRulesDetail';
import { TenantHierarchyTree } from '../components/TenantHierarchyTree';
import React, { useContext } from 'react';
import { TmsContext } from '../TmsContext';
import { ComponentErrorBoundary } from '@app/utilities';

import { useOrganisationHierarchy } from '@app/sdk';
import { SideListHeader } from '../components/ListHeader';
import { MasterDetailLayout } from '../components/MasterDetailLayout';
import { Segment } from 'semantic-ui-react';

export function ConfigRules() {
  const { selectedOu } = useContext(TmsContext);
  const { data: tenantHierarchy, isLoading } = useOrganisationHierarchy();

  const master = (
    <Segment>
      <SideListHeader>Config Rules</SideListHeader>
      <TenantHierarchyTree organisationHierarchy={tenantHierarchy} />
    </Segment>
  );

  const detail = (
    <Segment>
      {!selectedOu ? (
        <section>Please select an Organisation Unit</section>
      ) : (
        <ConfigRulesDetail selectedOu={selectedOu} tenantHierarchy={tenantHierarchy} />
      )}
    </Segment>
  );

  return (
    <ComponentErrorBoundary>
      {isLoading && <div className="ui active centered inline loader" />}
      {!isLoading && tenantHierarchy && (
        <MasterDetailLayout master={master} detail={detail} masterWidth={'four'} detailWidth={'twelve'} />
      )}
    </ComponentErrorBoundary>
  );
}
